export const INVOICE_SCROLL_KEY = "invoice_scroll_top";
export const INVOICE_FILTER_KEY = "invoice_filter";
export const INVOICE_REFETCH_KEY = "invoice_needs_refetch";
